import { BasicClientCommand } from "./BasicClientCommand";
/**
 * Created with IntelliJ IDEA.
 * User: glesouchu
 * Date: 16.05.14
 * Time: 10:45
 * To change this template use File | Settings | File Templates.
 */


import { BasicModel } from "../../model/BasicModel";
import { InstanceVOProxy } from "../../model/proxy/InstanceVOProxy";
import {NetworkInstance} from "@goodgamestudios/world-assignment";

export class BasicInitZoneCapacityCommand extends BasicClientCommand {
    public /*final*/ execute(commandVars: any = null): void {
        let zoneCapacity: any = commandVars.zoneCapacity;

        let instanceProxy: InstanceVOProxy = BasicModel.instanceProxy;
        let allInstances: NetworkInstance[] = instanceProxy.instanceMap;
        let l: number = allInstances.length;
        for (let i: number = 0; i < l; i++) {
            let instanceVO: NetworkInstance = allInstances[i];
            instanceVO.remainingRegistrationCapacity = this._getCapacityForZone(instanceVO.zoneId, zoneCapacity.zones);
        }
    }

    protected _getCapacityForZone(zone: number, capacities: any[]): number {
        let r: number = -1;
        let l: number = capacities.length;
        for (let i: number = 0; i < l; i++) {
            let obj: any = capacities[i];
            if (obj.zoneId == zone) {
                r = obj.remainingRegistrationCapacity;
                break;
            }
        }
        return r;
    }
}

